module.exports = __webpack_public_path__ + "assets/images/packed.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/packed.png
// module id = 404
// module chunks = 1